import { HStack, Progress as Prog, Stack, useBreakpointValue, Text } from '@chakra-ui/react';

interface Fraction {
    total: number;
    active: number;
}

export interface PercentTrackerProps {
    colorScheme?: string;
    value: number | Fraction;
}

export const Progress = ({ value, colorScheme = 'blue' }: PercentTrackerProps) => {
    //scale bar to fit screen size
    const barWidth = useBreakpointValue({
        base: '20em',
        sm: '20em',
        md: '30em',
        lg: '40em',
        xl: '40em',
    });

    let progress = typeof value === 'number' ? value : Math.round((value.active / value.total) * 100);

    if (progress > 100) {
        progress = 100;
    }

    return (
        <Stack direction="column" py={4}>
            <HStack>
                <Prog value={progress} borderRadius="md" h="0.75em" w={barWidth} variant={colorScheme} />
                <Text fontWeight="semibold">{`${progress}%`}</Text>
            </HStack>
        </Stack>
    );
};
